<template>
  <a-form class="flex-grow-1 d-flex flex-column overflow-y-hidden" :form="addDomainForm" @submit="onSubmit">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">
        Add Configuration
      </span>
    </div>
    <div class="a-body p-20-px flex-grow-1 d-flex flex-column overflow-y-auto">
      <transition name="slide-up">
        <a-alert v-if="isAddDomainSuccess && !isShowProgressAddDomain" showIcon type="success">
          <template slot="message">
            Domain successfully added.
          </template>
        </a-alert>
      </transition>
      <transition>
        <div v-if="!isAddDomainSuccess" class="slide-up-enter-active">
          <div>
            <a-row :gutter="[8, 8]" type="flex">
              <a-col :sm="24" :md="16">
                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" label="Domain Name">
                  <a-input
                    v-decorator="[
                      'domainName',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please enter domain',
                          },
                          { validator: validateDomain },
                        ],
                      },
                    ]"
                    autocomplete="off"
                    placeholder="eg. www.banffcyber.com or https://www.banffcyber.com"
                  />
                </a-form-item>
              </a-col>
              <a-col :sm="24" :md="8">
                <transition name="slide-up">
                  <a-form-item v-show="addDomainForm.getFieldValue('sslCert')" :label-col="FormItemLayout.labelCol" :wrapper-col="FormItemLayout.wrapperCol" label="Port">
                    <a-input
                      v-decorator="[
                        'port',
                        {
                          initialValue: '443',
                          rules: [{ validator: validateIntegerNumber }],
                        },
                      ]"
                      placeholder="Port"
                    />
                  </a-form-item>
                </transition>
              </a-col>
            </a-row>
            <a-row :gutter="[8, 8]" type="flex">
              <a-col :span="24">
                <a-form-item :label-col="FormItemLayout.labelCol" :wrapper-col="FormItemLayout.wrapperCol" label="Please select items to monitor" />
              </a-col>
            </a-row>
            <a-row :gutter="[8, 8]" type="flex">
              <a-col :sm="24" :md="12" :lg="8">
                <a-form-item :label-col="FormItemLayout.labelCol" :wrapper-col="FormItemLayout.wrapperCol" label="SSL Certificate">
                  <a-switch
                    v-decorator="[
                      'sslCert',
                      {
                        valuePropName: 'checked',
                        initialValue: false,
                      },
                    ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :sm="24" :md="12" :lg="8">
                <transition name="slide-up">
                  <a-form-item v-show="addDomainForm.getFieldValue('sslCert')" :label-col="FormItemLayout.labelCol" :wrapper-col="FormItemLayout.wrapperCol" label="Contact Group">
                    <a-select
                      v-decorator="[
                        'sslCertContactGroup',
                        {
                          initialValue: initDefaultContactGroup,
                        },
                      ]"
                      size="large"
                    >
                      <a-select-option v-for="contactGroup in contactGroups" :key="contactGroup.value" :value="contactGroup.value">
                        {{ contactGroup.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </transition>
              </a-col>
              <a-col :sm="24" :md="12" :lg="8">
                <transition name="slide-up">
                  <a-form-item v-show="addDomainForm.getFieldValue('sslCert')" :label-col="FormItemLayout.labelCol" :wrapper-col="FormItemLayout.wrapperCol" label="Monitoring Interval">
                    <a-select
                      v-decorator="[
                        'sslCertInterval',
                        {
                          initialValue: 'PT8H',
                        },
                      ]"
                      size="large"
                    >
                      <a-select-option v-for="time in SslDnsIntervals" :key="time.value" :value="time.value">
                        {{ time.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </transition>
              </a-col>
            </a-row>
            <a-row :gutter="[8, 8]" type="flex">
              <a-col :sm="24" :md="12" :lg="8">
                <a-form-item :label-col="FormItemLayout.labelCol" :wrapper-col="FormItemLayout.wrapperCol" label="DNS Records">
                  <a-switch
                    v-decorator="[
                      'dnsRecords',
                      {
                        valuePropName: 'checked',
                        initialValue: true,
                      },
                    ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :sm="24" :md="12" :lg="8">
                <transition name="slide-up">
                  <a-form-item v-show="addDomainForm.getFieldValue('dnsRecords')" :label-col="FormItemLayout.labelCol" :wrapper-col="FormItemLayout.wrapperCol" label="Contact Group">
                    <a-select
                      v-decorator="[
                        'dnsRecordsContactGroup',
                        {
                          initialValue: initDefaultContactGroup,
                        },
                      ]"
                      size="large"
                    >
                      <a-select-option v-for="contactGroup in contactGroups" :key="contactGroup.value" :value="contactGroup.value">
                        {{ contactGroup.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </transition>
              </a-col>
              <a-col :sm="24" :md="12" :lg="8">
                <transition name="slide-up">
                  <a-form-item v-show="addDomainForm.getFieldValue('dnsRecords')" :label-col="FormItemLayout.labelCol" :wrapper-col="FormItemLayout.wrapperCol" label="Monitoring Interval">
                    <a-select
                      v-decorator="[
                        'dnsRecordsInterval',
                        {
                          initialValue: 'PT8H',
                        },
                      ]"
                      size="large"
                    >
                      <a-select-option v-for="time in SslDnsIntervals" :key="time.value" :value="time.value">
                        {{ time.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </transition>
              </a-col>
            </a-row>
            <a-row :gutter="[8, 8]" type="flex">
              <a-col :sm="24" :md="12" :lg="8">
                <a-form-item :label-col="FormItemLayout.labelCol" :wrapper-col="FormItemLayout.wrapperCol" label="WHOIS Record">
                  <a-switch
                    v-decorator="[
                      'whoisRecord',
                      {
                        valuePropName: 'checked',
                        initialValue: true,
                      },
                    ]"
                  />
                </a-form-item>
              </a-col>
              <a-col :sm="24" :md="12" :lg="8">
                <transition name="slide-up">
                  <a-form-item v-show="addDomainForm.getFieldValue('whoisRecord')" :label-col="FormItemLayout.labelCol" :wrapper-col="FormItemLayout.wrapperCol" label="Contact Group">
                    <a-select
                      v-decorator="[
                        'whoisRecordContactGroup',
                        {
                          initialValue: initDefaultContactGroup,
                        },
                      ]"
                      size="large"
                    >
                      <a-select-option v-for="contactGroup in contactGroups" :key="contactGroup.value" :value="contactGroup.value">
                        {{ contactGroup.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </transition>
              </a-col>
              <a-col :sm="24" :md="12" :lg="8">
                <transition name="slide-up">
                  <a-form-item v-show="addDomainForm.getFieldValue('whoisRecord')" :label-col="FormItemLayout.labelCol" :wrapper-col="FormItemLayout.wrapperCol" label="Monitoring Interval">
                    <a-select
                      v-decorator="[
                        'whoisRecordInterval',
                        {
                          initialValue: 'PT24H',
                        },
                      ]"
                      size="large"
                    >
                      <a-select-option v-for="time in WhoisIntervals" :key="time.value" :value="time.value">
                        {{ time.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </transition>
              </a-col>
            </a-row>
          </div>
        </div>
      </transition>
    </div>
    <div class="a-footer">
      <a-button v-if="!isAddDomainSuccess" key="back" size="large" class="mr-3 slide-down-enter-active">
        <router-link :to="'/domain-monitoring'">
          Cancel
        </router-link>
      </a-button>
      <a-button v-if="!isAddDomainSuccess" key="submit" size="large" type="primary" html-type="submit" class="slide-down-enter-active">
        Save
      </a-button>
      <a-button v-if="isAddDomainSuccess" key="back" size="large" class="slide-down-enter-active">
        <router-link :to="'/domain-monitoring/list'">
          Complete
        </router-link>
      </a-button>
    </div>
    <a-modal v-model="isShowProgressAddDomain" class="progress-modal" :footer="null" title="" :closable="false" :maskClosable="false">
      <div>
        <p class="mb-1 text-center progress-notice">
          <a-icon type="sync" spin :style="{ color: '#e74c3c' }" />
          Adding domain now...
        </p>
        <template v-for="(messageAddDomain, index) in messagesAddingDomain">
          <a-alert :key="index" :message="messageAddDomain.text" :type="messageAddDomain.type" showIcon />
        </template>
      </div>
    </a-modal>
  </a-form>
</template>

<script>
  const DomainPattern = /(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
  const FormItemLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 14 },
  };
  import DomainMonitorService from '../services/DomainMonitor.service';
  import { SSL_DNS_INTERVALS, WHOIS_INTERVALS } from '../consts/monitoringInterval.const';

  export default {
    name: 'DomainMonitorAdd',
    data() {
      return {
        FormItemLayout,
        SslDnsIntervals: SSL_DNS_INTERVALS,
        WhoisIntervals: WHOIS_INTERVALS,
        initDefaultContactGroup: 0,
        contactGroups: [],
        isAddDomainSuccess: false,
        isShowProgressAddDomain: false,
        messagesAddingDomain: [],
      };
    },
    beforeCreate() {
      this.addDomainForm = this.$form.createForm(this, {
        name: 'user-detail-form',
        onFieldsChange: (_, values) => {},
      });
    },
    mounted() {
      this.fetchContactGroup();
    },
    methods: {
      validateDomain(rule, value, callback) {
        if (value && !DomainPattern.test(value)) {
          callback('Please input a valid domain');
        } else {
          callback();
        }
      },
      validateIntegerNumber(rule, value, callback) {
        if (value && (isNaN(value) || +value < 0)) {
          callback('Please input positive integer number');
        } else {
          callback();
        }
      },
      onSubmit(e) {
        e.preventDefault();
        this.addDomainForm.validateFieldsAndScroll(async (err, valuesForm) => {
          if (!err) {
            const { dnsRecords, sslCert, whoisRecord } = valuesForm;
            const asLeastCheckboxChecked = dnsRecords || sslCert || whoisRecord;
            if (!asLeastCheckboxChecked) {
              this.$showErrorMessage('You must enable at least one monitoring scheme');
            } else {
              this.addDomain(valuesForm);
            }
          }
        });
      },
      async addDomain(valuesForm) {
        const { domainName, port, dnsRecords, dnsRecordsContactGroup, dnsRecordsInterval, sslCert, sslCertContactGroup, sslCertInterval, whoisRecord, whoisRecordContactGroup, whoisRecordInterval } = valuesForm;
        const formattedDomainName = domainName
          .toString()
          .replace(/https?\:\/\//gim, '')
          .replace(/\/$/, '');
        const bodySSL = {
          domain: formattedDomainName,
          port: port && sslCert ? +port : 443,
          contact_group_id: sslCertContactGroup,
          interval: sslCertInterval,
        };
        const bodyDNS = {
          domain: formattedDomainName,
          contact_group_id: dnsRecordsContactGroup,
          interval: dnsRecordsInterval,
        };
        const bodyWHOIS = {
          domain: formattedDomainName,
          contact_group_id: whoisRecordContactGroup,
          interval: whoisRecordInterval,
        };

        this.isShowProgressAddDomain = true;
        this.isAddDomainSuccess = false;
        if (dnsRecords) {
          await this.addDns(bodyDNS);
          await this.sleep(800);
        }
        if (sslCert) {
          await this.addSsl(bodySSL);
          await this.sleep(800);
        }
        if (whoisRecord) {
          await this.addWhois(bodyWHOIS);
          await this.sleep(800);
        }
        setTimeout(() => {
          this.isShowProgressAddDomain = false;
          this.messagesAddingDomain.length = 0;
          if (this.isAddDomainSuccess) {
            this.$router.push('/domain-monitoring/list');
          }
        }, 300);
      },
      async sleep(milliseconds) {
        return new Promise(resolve => setTimeout(resolve, milliseconds));
      },
      async addDns(bodyDNS) {
        try {
          await DomainMonitorService.addDns(bodyDNS);
          this.messagesAddingDomain.push({ text: 'Monitor DNS records - Successfully', type: 'success' });
          this.isAddDomainSuccess = true;
        } catch (error) {
          const messageErr = (error && error.messages && error.messages[0]) || '';
          this.messagesAddingDomain.push({ text: `Monitor DNS records - Error: ${messageErr}`.trim(), type: 'error' });
          this.$notification.error({
            class: 'custom-notification error-message',
            message: 'Error',
            description: messageErr,
            duration: 10,
          });
          if (!this.isAddDomainSuccess) {
            this.isAddDomainSuccess = false;
          }
        }
      },
      async addSsl(bodySSL) {
        try {
          await DomainMonitorService.addSsl(bodySSL);
          this.messagesAddingDomain.push({ text: 'Monitor SSL Certificate - Successfully', type: 'success' });
          this.isAddDomainSuccess = true;
        } catch (error) {
          const messageErr = (error && error.messages && error.messages[0]) || '';
          this.messagesAddingDomain.push({ text: `Monitor SSL Certificate - Error: ${messageErr}`.trim(), type: 'error' });
          this.$notification.error({
            class: 'custom-notification error-message',
            message: 'Error',
            description: messageErr,
            duration: 10,
          });
          if (!this.isAddDomainSuccess) {
            this.isAddDomainSuccess = false;
          }
        }
      },
      async addWhois(bodyWHOIS) {
        try {
          await DomainMonitorService.addWhois(bodyWHOIS);
          this.messagesAddingDomain.push({ text: 'Monitor WHOIS record - Successfully', type: 'success' });
          this.isAddDomainSuccess = true;
        } catch (error) {
          const messageErr = (error && error.messages && error.messages[0]) || '';
          this.messagesAddingDomain.push({ text: `Monitor WHOIS record - Error: ${messageErr}`.trim(), type: 'error' });
          this.$notification.error({
            class: 'custom-notification error-message',
            message: 'Error',
            description: messageErr,
            duration: 10,
          });
          if (!this.isAddDomainSuccess) {
            this.isAddDomainSuccess = false;
          }
        }
      },
      async fetchContactGroup() {
        const contactGroups = await DomainMonitorService.fetchContactGroups();
        this.contactGroups = (contactGroups || []).map(contactGroup => {
          if (contactGroup.description === 'DEFAULT') {
            this.initDefaultContactGroup = contactGroup.id;
          }
          return {
            label: contactGroup.description,
            value: contactGroup.id,
          };
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .progress-notice {
    font-size: 1rem;
  }
</style>
